<mat-toolbar color="primary" class="flex-row items-center">
  @if (!gridStore.changes) {
    <h3>{{ 'scheduler.setup.resources.title' | translate }}</h3>
  }
  @if (gridStore.changes) {
    <h3>
      <i>{{ 'scheduler.setup.resources.title' | translate }}*</i>
    </h3>
  }

  <span class="flex-spacer"></span>
  
  <!-- Import/Export button - opens wizard with download options -->
  <button (click)="openImportWizard()" class="button-margin-right" mat-icon-button aria-label="Import/Export data" matTooltip="Import/Export Data">
    <mat-icon fontIcon="fa-file-import" fontSet="fas"></mat-icon>
  </button>
  
  <button (click)="openNewResourceDialog()" class="button-margin-right" mat-icon-button aria-label="Add new resource">
    <mat-icon fontIcon="fa-plus" fontSet="fas"></mat-icon>
  </button>

  <!--  <button mat-flat-button color="warn" class="button-margin-right" (click)="undo()"-->
  <!--          [disabled]="pristine"-->
<!--  >{{ 'scheduler.general.discardChanges' | translate}}</button>-->
<!--  <button mat-flat-button color="accent" (click)="commit()"-->
<!--          [disabled]="pristine"-->
<!--  >{{ 'scheduler.general.saveChanges' | translate }}</button>-->

</mat-toolbar>
<div class="grid-container">
  <app-grid (gridEvents)="onEvent($event)" [columns]="columns" [filter]="filterConfig" [readOnly]="true"
    [showContextMenu]="true" [showDirty]="true" [showRemoveRowInContextMenu]="false" [store]="gridStore"
  [width]="'calc(100vw)'"></app-grid>
</div>
<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
  [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
  hidePageSize="false" showFirstLastButtons="true">
</mat-paginator>